import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import './Home.css';

import Projects from '../Projects/Projects';
import Contact from '../Contact/Contact';
import About from '../About/About';
import Article from '../Article/Article';
import Expertise from '../Expertise/Expertise';



const Home = () => {
    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, [])
    return (
        <div className='w-11/12 mx-auto overflow-hidden'>
            <div>
                <About></About>
            </div>
           
            <div className='lg:mt-10'>
                <Projects></Projects>
            </div>

            <div>
                <Expertise></Expertise>
            </div>

            <div>
                <Article></Article>
            </div>

            <div>
                <Contact></Contact>
            </div>
        </div>
    );
};

export default Home;